//imports
import {
    FORGOT_PASSWORD_REQUEST,
    FORGOT_PASSWORD_RESULT,
   
    CLEAR_REDUX,
} from "Redux/actionTypes";

//initial values
const INIT_STATE = {
    loading: false,
    cognitoValues: null,
    error: null,
    showConfirm: false,
    token: null,
    openModal: false,
    recoveryPassword: false,
    errorForgotPassword: null,
    resultForgotPassword: null,
    errorConfirmForgotPassword: null,
    resultConfirmForgotPassword: null,
    resultChangePassword: null,
    username: null,
    session: null,
    openModalChangePassword: false,
    resultChangePassword: null,
    errorChangePassword: false,
};

//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FORGOT_PASSWORD_REQUEST:
            return { ...state, loading: true, error: null };

        case FORGOT_PASSWORD_RESULT:
            return { ...state, loading: false, resultChangePassword: action.payload.result, error: action.payload.error };

        case CLEAR_REDUX:
            return ["", "FORGOT_PASSWORD"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};
